export var LOG_LOADING = "@@firekit/LOADING@LOG_LOADING";
export var CLEAR_LOADING = "@@firekit/LOADING@CLEAR_LOADING";
export var CLEAR_ALL_LOADINGS = "@@firekit/LOADING@CLEAR_ALL_LOADINGS";